import React, { useEffect, useState, useCallback } from "react";
import Select from "react-select";
import swal from "sweetalert";
import { useNavigate } from "react-router-dom";
import { Button } from 'react-bootstrap';
import { ChevronDown } from "lucide-react";

import { getAllUserProfileList } from "../../../services/userApiService/userService";
import DigitalCertificates from './ProfileSections/DigitalCertificates.jsx';

const ProfileComp = ({ user_category_main_id, user_id }) => {
  const [profileImage, setProfileImage] = useState(
    "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"
  );
  const [userData, setUserData] = useState({});
  const [inputBlog, setInputBlog] = useState([]);
  const [userProfileImage, setUserProfileImage] = useState(null);

  const [isCertOpen, setIsCertOpen] = useState(false);
  // Replace with your options
  const options2 = []; // Gender options
  const options3 = []; // Country options
  const options4 = []; // City options
  const id = localStorage.getItem('id');
  const userCategoryMain = localStorage.getItem('user_category_main');
  const navigate = useNavigate();

  const [countryOptions, setCountryOptions] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);

  const handleChange = (e) => {
    let file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setProfileImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserData((prevData) => ({ ...prevData, [name]: value }));
  };

  const profileImageData = Array.isArray(userData?.organization_docs)
    ? userData.organization_docs.find((item) => item.doc_name === "profile_image")
    : null;

  const fetchUserData = useCallback(async () => {
    try {
      const response = await getAllUserProfileList(userCategoryMain, id);
      if (response?.data?.data) {
        setUserData(response.data.data);
      } else {
        setUserData({});
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      setUserData({});
    }
  }, [userCategoryMain, id]);

  useEffect(() => {
    if (userCategoryMain && id) {
      fetchUserData();
    }
  }, [fetchUserData, userCategoryMain, id]);

  return (
    <>
      <div className="row">
        {/* LEFT COLUMN: Sidebar */}
        <div className="col-12 col-lg-4 col-xl-3 mb-4 align-self-start">
          <div className="card card-bx profile-card author-profile border-0 shadow-sm">
            <div className="card-body">
              <div className="p-2">
                <div className="author-profile">
                  <div className="author-media profile-avatar-wrap" style={{ position: "relative", width: "100%", height: "200px" }}>
                    {userProfileImage ? (
                      <img
                        src={userProfileImage}
                        alt="Profile"
                        style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "50%" }}
                        onError={(e) => { e.target.onerror = null; e.target.src = profileImage; }}
                      />
                    ) : (
                      <img
                        src={userData?.indivisual?.[9]?.doc_file || profileImageData?.doc_file || profileImage}
                        alt="Profile"
                        style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "50%" }}
                      />
                    )}
                  </div>
                  <div>
                    {(userData?.name ||
                      userData?.name_of_legel_entity) && (
                        <div style={{ display: "flex", marginBottom: "8px" }}>
                          <strong className="label_font">Name :</strong>
                          <span className="mx-2  label_font_value">
                            {userData.name ||
                              userData?.name_of_legel_entity}
                          </span>
                        </div>
                      )}

                    {userData?.organization_profile?.name_of_organization && (
                      <div style={{ display: "flex", marginBottom: "8px" }}>
                        <strong className="label_font">Name of Org :</strong>
                        <span className="mx-2 label_font_value">
                          {userData.organization_profile.name_of_organization}
                        </span>
                      </div>
                    )}

                    {userData?.organization_profile?.parent
                      ?.category_name_view && (
                        <div style={{ display: "flex", marginBottom: "8px" }}>
                          <strong className="label_font">Category Name :</strong>
                          <span className="mx-2 label_font_value">
                            {
                              userData.organization_profile.parent
                                .category_name_view
                            }
                          </span>
                        </div>
                      )}
                  </div>
                </div>
              </div>
            </div>
            <div className="card-footer">
              <Button
                variant="danger"
                className="w-100 text-white"
                onClick={() => navigate("/user/delete-account")}
              >
                Delete Account
              </Button>
            </div>
          </div>
        </div>

        {/* RIGHT COLUMN: Content */}
        <div className="col-12 col-lg-8 col-xl-9 align-self-start">
          {/* Main User Form */}
          <div className="card profile-card border-0 shadow-sm mb-4">
            <form className="profile-form">
              <div className="card-body p-4">
                <div className="row gy-4 gx-4">
                  {inputBlog?.map((item, ind) => (
                    <div className="col-12 col-sm-6" key={ind}>
                      <label className="form-label text-muted">{item.label}</label>
                      <input type="text" className="form-control" defaultValue={item.value} />
                    </div>
                  ))}
                  <div className="col-12 col-sm-6">
                    <label className="form-label text-muted">Atom ID</label>
                    <input type="text" onChange={handleInputChange} className="form-control" value={userData?.atom_id || ""} name="registration number" />
                  </div>
                  <div className="col-12 col-sm-6">
                    <label className="form-label text-muted">Email address</label>
                    <input type="text" className="form-control" readOnly value={userData?.email || ""} name="email" onChange={handleInputChange} />
                  </div>
                  <div className="col-12 col-sm-6">
                    <label className="form-label text-muted">Phone</label>
                    <input type="text" onChange={handleInputChange} className="form-control" value={(userData?.indivisual || userData?.organization)?.mobile || ""} name="phone" />
                  </div>
                  <div className="col-12 col-sm-6">
                    <label className="form-label text-muted">Address</label>
                    <input type="text" onChange={handleInputChange} className="form-control" value={(userData?.indivisual || userData?.organization)?.address || ""} name="address" />
                  </div>
                  <div className="col-12 col-sm-6">
                    <label className="form-label text-muted">Pincode</label>
                    <input type="text" onChange={handleInputChange} className="form-control" value={(userData?.indivisual || userData?.organization)?.pincode || ""} name="pincode" />
                  </div>
                  <div className="col-12 col-sm-6">
                    <label className="form-label text-muted">Country</label>
                    <input type="text" className="form-control" value={(userData?.indivisual || userData?.organization)?.country_name || ""} readOnly />
                  </div>
                  <div className="col-12 col-sm-6">
                    <label className="form-label text-muted">State</label>
                    <input type="text" className="form-control" value={(userData?.indivisual || userData?.organization)?.state_name || ""} readOnly />
                  </div>
                  <div className="col-12 col-sm-6">
                    <label className="form-label text-muted">District</label>
                    <input type="text" className="form-control" value={(userData?.indivisual || userData?.organization)?.city_name || ""} readOnly />
                  </div>
                </div>
              </div>
            </form>
          </div>

          {/* ACCORDION BLOCK */}
          <div className="card mb-3 border-0 rounded shadow-sm">
            <div
              className="card-header bg-white border-0 py-4 d-flex justify-content-between align-items-center"
              onClick={() => setIsCertOpen(!isCertOpen)}
              style={{ cursor: "pointer" }}
            >
              <h5 className="mb-0 fw-medium fs-5 text-dark">
                Digital Certificates & Accreditation
              </h5>
              <ChevronDown size={22} className="text-dark" style={{ transform: isCertOpen ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.3s ease" }} />
            </div>

            {isCertOpen && (
              <div className="card-body pt-0 border-top px-4 pb-4">
                <DigitalCertificates userData={userData} />
              </div>
            )}
          </div>

        </div>
      </div>
    </>
  );
};

export default ProfileComp;